// Tenantra Inc. - Careers shared layout
import { Logo } from '@/components/Logo';

export const STAGE_LABELS = {
  submitted: 'Submitted',
  in_review: 'In review',
  interview: 'Interview',
  offer: 'Offer',
  hired: 'Hired',
  rejected: 'Not selected'
};

export const STAGE_COLORS = {
  submitted: 'bg-slate-400',
  in_review: 'bg-amber-500',
  interview: 'bg-blue-500',
  offer: 'bg-teal-600',
  hired: 'bg-emerald-600',
  rejected: 'bg-slate-300'
};

export const StageDot = ({ stage }) => (
  <span className="inline-flex items-center gap-1.5 text-xs text-slate-700" data-testid={`stage-${stage}`}>
    <span className={`w-1.5 h-1.5 rounded-full ${STAGE_COLORS[stage] || 'bg-slate-300'}`}></span>
    {STAGE_LABELS[stage] || stage}
  </span>
);

export const CareersLayout = ({ children, right }) => (
  <div className="min-h-screen bg-white">
    <header className="border-b border-slate-200">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 h-14 flex items-center justify-between">
        <a href="/" data-testid="careers-logo"><Logo size="md" /></a>
        <nav className="flex items-center gap-5 text-sm">
          <a href="/careers" className="text-slate-600 hover:text-slate-900" data-testid="careers-nav-jobs">Open positions</a>
          {right}
        </nav>
      </div>
    </header>
    <main className="max-w-5xl mx-auto px-4 sm:px-6 py-10 sm:py-14">{children}</main>
    <footer className="border-t border-slate-200 py-6">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 flex flex-col sm:flex-row items-center justify-between gap-2">
        <p className="text-xs text-slate-500">&copy; {new Date().getFullYear()} Tenantra Inc.</p>
        <a href="/privacy-policy" className="text-xs text-slate-500 hover:text-slate-800">Privacy Policy</a>
      </div>
    </footer>
  </div>
);
